import { WarrantyRegistrationReportServices } from "../services";
import { WarrantyRejectRegistrationReportConstants } from "../constants";
import { alertActions } from ".";

export const WarrantyRejectRegistrationReportActions = {
  getAll,
  loadingData,
  exportData,
};

function getAll(obj) {
  return (dispatch) => {
    dispatch(request());
    WarrantyRegistrationReportServices.fetchWarrantyRejectDataRpt(obj).then(
      (response) => {
        dispatch(loadingData(false));
        dispatch(success(response.ResponseData));

        var data = response.ResponseData;
        // if (data != null) {
        //   data.forEach(function (v) {
        //     delete v.TotalRows;
        //     delete v.ProductId;
        //   });
        // }
        dispatch(successExport(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: WarrantyRejectRegistrationReportConstants.GETALL_REQUEST };
  }
  function success(datas) {
    return { type: WarrantyRejectRegistrationReportConstants.GETALL_SUCCESS, datas };
  }
  function successExport(datas) {
    return { type: WarrantyRejectRegistrationReportConstants.GETEXPORT_SUCCESS, datas };
  }
  function failure(error) {
    return { type: WarrantyRejectRegistrationReportConstants.GETALL_FAILURE, error };
  }
}


function exportData(obj) {
  return (dispatch) => {
    dispatch(request());
    WarrantyRegistrationReportServices.fetchWarrantyRejectDataRpt(obj).then(
      (response) => {
        dispatch(loadingData(false));
        var data = response.ResponseData;
        if (data != null) {
          data.forEach(function (v) {
            delete v.TotalRows;
            delete v.ProductId;
          });
        }
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: WarrantyRejectRegistrationReportConstants.GETEXPORT_REQUEST };
  }
  function success(datas) {
    return { type: WarrantyRejectRegistrationReportConstants.GETEXPORT_SUCCESS, datas };
  }
  function failure(error) {
    return { type: WarrantyRejectRegistrationReportConstants.GETEXPORT_FAILURE, error };
  }
}

function loadingData(isbool) {
  return {
    type: WarrantyRejectRegistrationReportConstants.LOADING_REQUEST,
    isbool,
  };
}

